// // // src/components/TopBanner.js

import React from "react";
import "./TopBanner.css";


// import image1 from "../assets/banners/RunasArchiveBanner.png";
import image1 from "../assets/banners/runa-banner.png";
// import image2 from "../assets/banners/logo-final-transparent.png";
// import image3 from "../assets/banners/Tagore.png";


const ImageRow = () => {

  const imageUrl= image1
  // const imageUrl2= image2

  return (
    <div className="banner-container">
      <img src={imageUrl} alt="Banner" className="banner-image" />
    </div>
  );
};

export default ImageRow;


// // Import images from assets
// import image1 from "../assets/banners/Runa-Madam-Cover.png";
// import image2 from "../assets/banners/logo-final-transparent.png";
// import image3 from "../assets/banners/Tagore.png";

// const ImageRow = () => {
//   const images = [image1, image2, image3];

//   return (
//     <div className="image-grid-container">
//       {images.map((src, index) => (
//         <div key={index} className="image-wrapper">
//           <img src={src} alt={`${index + 1}`} className="image-grid-item" />
//         </div>
//       ))}
//     </div>
//   );
// };

// export default ImageRow;




// // Import images from assets
// import image1 from "../assets/banners/Runa-Madam-Cover.png";
// import image2 from "../assets/banners/logo-final-transparent.png";
// import image3 from "../assets/banners/Tagore.png";

// const ImageRow = () => {
//   const images = [image1, image2, image3];

//   return (
//     <div className="image-row-container">
//       {images.map((src, index) => (
//         <div key={index} className="image-wrapper">
//           <img src={src} alt={`${index + 1}`} className="image-item" />
//         </div>
//       ))}
//     </div>
//   );
// };

// export default ImageRow;




// import React from "react";
// import "./TopBanner.css"; // CSS file for responsive styles

// const TopBanner = () => {

// const images = [
//     "/assets/banners/Runa-Madam-Cover.png",
//     "/assets/images/Runa's-Archive-white-bg.png",
//     "/assets/banners/Tagore.png",
//   ];
//   return (
//     <div className="image-row-container">
//       {images.map((src, index) => (
//         <img key={index} src={src} alt={`${index + 1}`} className="image-item" />
//       ))}
//     </div>
//   );
//   // return (
//   //   <div className="top-banner">
//   //     <div className="banner-overlay">
//   //       <img src="/assets/Runa-Madam-Cover.png" alt="Left" className="banner-left" />
//   //       <img
//   //         src="/assets/Tagore.png"
//   //         alt="Right"
//   //         className="banner-right"
//   //       />
//   //     </div>
//   //     <img
//   //       src="/assets/background-banner.jpg"
//   //       alt="Background"
//   //       className="banner-background"
//   //     />
//   //   </div>
//   // );
// };

// export default TopBanner;
